import { AccountantService, AuthService, TaxProfileService } from "../../../services";
import { BackdropCircularProgress, DeleteConfirmationDialog, EmptyList, EnhancedDropDownRHFWithLabel, EnhancedSnackbar, IResponse, IServerError, LabelPosition, PhoneNumberRHF, RouterLinkButton, SubmitButton, SubmitButtonVariant } from "@websential/cosmic";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import {
  INITIAL_PAGE_SIZE,
  INITIAL_SNACKBAR_DATA,
  MOVE_CLIENTS_SCREEN_SLUG,
  ROWS_PER_PAGE_PER_OPTIONS,
  SEARCH_DEBOUNCE_DELAY_IN_SECONDS,
} from "../../../common/constants";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { setSelectedClient, setSelectedClientName, setUserMenuOpen } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ComponentState } from "../../../common/enums";
import { EmptyAccountantList } from "../../Accountant/EmptyAccountantList";
import { EnhancedDataGrid } from "../../EnhancedDataGrid";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { clearError } from "../../../store/actions/viewStateActions";
import { format } from "date-fns";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { toSnake } from "../../../common/methods";
import { useNavigate } from "react-router-dom";

// import { EnhancedDDLBulkAction } from "@websential/ws-react-ui/lib/components/EnhancedDDLBulkAction";
// import { EnhancedDialog } from "@websential/ws-react-ui/lib/components/EnhancedDialog";
// import { ErrorState } from "@websential/ws-react-ui/lib/components/ErrorState/ErrorState";
// import { StatusChip } from "@websential/ws-react-ui/lib/components/StatusChip";













export interface IMoveClients { }
const CLIENT_LIST_QUERY_KEY = "clients-list";


const useClients = (accountantId: string, isAdminUser: number, params: IGetListRequest) =>
  useQuery({
    queryKey: ["clients-list", accountantId, isAdminUser, params],
    queryFn: (data) => {

      return AccountantService.getClientsByAccountantId(accountantId, isAdminUser, params);
    },
    refetchOnWindowFocus: false
  });

const useGetAccountantsDropDownList = () =>
  useQuery({
    queryKey: ["get-accountant-dll"],
    queryFn: () => { return TaxProfileService.getAccountantsDropDownList() },
    refetchOnWindowFocus: false
  });

export const MoveClients: React.FC<IMoveClients> = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdminUser = useSelector((state: IAppState) => state.user.profile.isSuperStatus);
  const clientIdStore = useSelector((state: IAppState) => state.client.id);


  // for delete row Purpose
  const queryClient = useQueryClient();
  const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
const [moveClientsUpdatedItems, setMoveClientsUpdatedItems] =
    useState<any>(undefined);
  const [queryParams, setQueryParams] = useState<IGetListRequest>({
    search_query: "",
    order_by: "clientName",
    order_direction: "asc",
    page: 1,
    size: 25,
  });

  const {
    isLoading: isLoadingAccountantDropDownList,
    data: accountantList,
    // refetch: refetchTabsDDL,
  } = useGetAccountantsDropDownList();

  const { id } = useSelector((state: IAppState) => state.accountant);
  const { isLoading, data } = useClients(String(id), isAdminUser, queryParams); //useQuery('accountants-list', AccountantService.getAccountantList, refetchOnWindowFocus: false);
  const MoveClients: any | null = data;

  useEffect(() => {
    if (MoveClients && MoveClients.items && MoveClients.items.length === 1 && zeroClient === true) {
      // dispatch(setSelectedClient(MoveClients.items[0]));
      if (clientIdStore !== "") {
        let path = '/clients/dashboard'
        navigate(path)
      }
    }
    if (MoveClients && MoveClients.message && MoveClients.message.detail === "Invalid token or expired token.") {
      let path = '/logout'
      navigate(path)
    }
  }, [MoveClients])

  const { message, componentState } = useSelector(
    (state: IAppState) => state.viewState
  );

  // const { accountantList } = useSelector(
  //   (state: IAppState) => state.accountant
  // );

  const [openDialog, setDialogOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [statusValue, setStatusValue] = useState("");
  const [apiAction, setApiAction] = useState("");
  const [emptyList, setEmptyList] = useState(false);
  const [searchText, setSearchText] = useState({});
  const [zeroClient, setzeroClient] = useState(true);

  // for delete row
  const [singleDelete, setSingleDelete] = useState<boolean>(false);
  const [clientId, setClientId] = useState<number>(0);

  // Bulk Delete
  const [bulkDelete, setBulkDelete] = useState<boolean>(false);
  const [bulkClientId, setBulkClientId] = useState<any>({});
  const [bulkClientDelete, setBulkClientDelete] = useState<boolean>(false);

  const onRequestParamsChange = useCallback((requestParams: any) => {

    let dispatchParams = {
      search_query: requestParams.debouncedSearchQuery,
      order_by: "clientName",
      order_direction: "asc",
      page: requestParams.currentPage + 1,
      size: requestParams.pageSize,
    };
    if (requestParams.sort) {
      const [sortBy, sortDirection] = requestParams.sort.split(",");
      dispatchParams.order_by = toSnake(sortBy);
      dispatchParams.order_direction = sortDirection;
    }

    // setQueryParams(dispatchParams);
    if (dispatchParams.search_query === '') {
      setQueryParams(dispatchParams);
    }
    setSearchText(dispatchParams)
  }, []);

  const onSearchButtonClicked = () => {
    setQueryParams(searchText)
    setzeroClient(false)
  }

  const onRowEditClicked = useCallback((params: any) => {
    // alert(`Edit row with ID: ${params.row.id} has been clicked!`);
    let path = `/clients/setup/${params.row.id}`;
    navigate(path);
  }, []);

  const onCloseHandler = () => {
    setDialogOpen(false);
  };

  const callAction = () => {
    if (apiAction === "delete") {
      alert(`Delete row with ID: ${selectedIds} has been clicked!`);
      // TODO api call for delete
    } else if (apiAction === "updateStatus") {
      alert(`action need to trigger : ${apiAction}`);
      // TODO api call for update status
    }
    setDialogOpen(false);
  };

  // For Delete Row
  const deleteClientField = () => {
    if (singleDelete) {
      setSingleDelete(false);
      deleteClientById(clientId);
      setDialogOpen(false);
    }
  };

  const onRowDeleteClicked = useCallback((params: any) => {
    setDialogOpen(true);
    setSingleDelete(true);
    setApiAction("delete");
    setClientId(params.row.id);

    // alert(`Delete row with ID: ${params.row.id} has been clicked!`);
  }, []);

  const onSnackbarClosed = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const { isPending: isDeleting, mutate: deleteClientById } = useMutation({
    mutationFn: AccountantService.delClient,

    onSuccess: (res: string | IServerError | IResponse | any) => {

      if (res) {
        // remove the cache of the Year fields since we just added a new field.
        setSnackbarData({
          open: true,
          message: res.message ? res.message : "Something went wrong.",
          severity: res.status === false ? "error" : "success",
        });
        queryClient.invalidateQueries({
          queryKey: [CLIENT_LIST_QUERY_KEY],
        });
      } else {
        setSnackbarData({
          open: true,
          message: "Something went wrong, try again later!",
          severity: "error",
        });
      }
    },
    onError: (err) => {
      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        message: "Something went wrong, try again later!",
        severity: "error",
      });
    },
  }
  );

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setStatusValue(event.target.value as string);
    setApiAction("updateStatus");
    setDialogOpen(true);
  };

  const onKeyFieldClickHandler = (clickedRow: any) => {
    dispatch(setSelectedClient(clickedRow));
    dispatch(setSelectedClientName(clickedRow));
  };

  //bulk delete

  const { isPending: isBulkDeleting, mutate: deleteBulkClients } =
    useMutation({
      mutationFn: AccountantService.delBulkClients,
      onSuccess: (res: any | string | IServerError | IResponse) => {
        if (typeof res === "object") {
          // remove the cache of the Year fields since we just added a new field.
          setSnackbarData({
            open: true,
            message: res.message ? res.message : "Something went wrong.",
            severity: res.status === false ? "error" : "success",
          });

          setBulkClientDelete(false)
          queryClient.invalidateQueries({
            queryKey: [CLIENT_LIST_QUERY_KEY],
          });
        } else {
          setSnackbarData({
            open: true,
            message: "Something went wrong, try again later!",
            severity: "error",
          });
        }
        setBulkClientDelete(false)
      },
      onError: (err: any) => {
        // TODO: customize the toast message based on the response
        setSnackbarData({
          open: true,
          message: err.message,
          severity: "error",
        });
        setBulkClientDelete(false)
      },
    });

  // For Bulk Delete
  const deleteBulkClientField = () => {
    if (bulkDelete) {
      setBulkDelete(false);
      deleteBulkClients(bulkClientId);
      setDialogOpen(false);
    }
  };

  const onRowMultipleDeleteClicked = (params: any) => {

    let bulkDeletePayload = {
      clientIds: { "clientIds": params }
    }
    setDialogOpen(true);
    setBulkDelete(true);
    setApiAction("delete");
    setBulkClientId(bulkDeletePayload);
    setBulkClientDelete(true);
  };

  const accountantDDLItems = useMemo(() => {
    if (accountantList && Array.isArray(accountantList)) {
      return accountantList.map((accountant: any) => ({
        label: accountant.label,
        value: accountant.value,
      }));
    }

    // Return empty array in case of API data fetching error
    return [];
  }, [accountantList]);


  const formMethods: any = useForm<any>({
    // resolver: yupResolver(FilingResourceSetupSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    // defaultValues: DEFAULT_VALUES,
  });

  const { isPending: isSubmitting, mutate: submitMoveClients } = useMutation({
    mutationFn: AccountantService.moveClientsByAccountantId,

    onSuccess: (res: IServerError | IResponse | any) => {
      if (res) {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: res.status === true ? "success" : "error",
        });
      }
    },
    onError: (err) => {
      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        message: "Something went wrong, try again later!",
        severity: "error",
      });
    },
  }
  );


  const selectionToolbar = useCallback((selectedItems: any) => {
    setSelectedIds(selectedItems);
    const onSubmit = (formData: any) => {

      if (selectedItems.length === 0) {
        setSnackbarData({
          open: true,
          message: "Please select clients to move",
          severity: "warning",
        });
      } else if (formData.changeAcc === undefined) {
        setSnackbarData({
          open: true,
          message: "Please select Accountant to move clients",
          severity: "warning",
        });
      } else {
        let payload = {
          clientIds: selectedItems,
          parentAccountantId: String(id),
          accountantId: formData.changeAcc
        }

        submitMoveClients(payload);
      }
    }

    return (
      <Box sx={{ width: "40%" }}>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)}>
            <Box sx={{ display: "flex" }}>
              <Box sx={{ width: "70%" }}>
                <EnhancedDropDownRHFWithLabel
                  selectName="changeAcc"
                  label="Change Accountant"
                  labelPosition={LabelPosition.Left}
                  items={accountantDDLItems}
                  isLoading={isLoadingAccountantDropDownList}
                  testId={`change-accountant-ddl`}
                />
              </Box>
              <Box sx={{ width: "30%", margin: "9px 0 0 10px", textAlign: "end" }}>

                <SubmitButton
                  label="Update Accountant"
                  testId="submit-button"
                  loading={false}
                  // icon={<PlaylistAddCheckOutlinedIcon />}
                  variant={SubmitButtonVariant.Primary}
                />
              </Box>
            </Box>
          </form></FormProvider>
      </Box>
    );
  }, [accountantDDLItems]);

  const formatDate = (datee: any) => {
      const originalDate = new Date(datee);
      const formattedDate = format(originalDate, "MMM dd, yyyy");
  
      return formattedDate;
    };
    
  //defualt drawer options set in home 
  useEffect(() => {
    const homeDrawerOptionsOpen = { id: 5000, text: "Home" }
    dispatch(setUserMenuOpen(homeDrawerOptionsOpen));

    if (MoveClients) {
      const updatedItemsResponse = MoveClients && MoveClients.items && MoveClients.items.map((item: any) => ({
        ...item,
        createdDate: (item.createdDate !== "" && item.createdDate !== null && item.createdDate && item.createdDate.charAt(3) !== "*") ? formatDate(item.createdDate) : item.createdDate,
      }));

      setMoveClientsUpdatedItems(updatedItemsResponse)
    }
  }, [MoveClients])


  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: "",
        entityId2: "",
        entityId3: "",
        screenName: MOVE_CLIENTS_SCREEN_SLUG,
        companyName: '',
        activityType:
          "activity_type=update_parent",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: false }));
  }, []);

  const image =
    "https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

  return MoveClients && MoveClients.items && MoveClients.items.length === 0 && zeroClient === true ? (
    <EmptyList
      showImage={true}
      imagePath={image}
      heading={`There's nothing! Add Client to proceed`}
      content={`You can add client by directly clicking on add client button.`}
      testId={"client-empty-list"}
      showAddButton={true}
      addButtonLabel={"Add Client"}
      navigateToAdd={"/clients/setup"}
      showImportButton={false}
      showImportXmlButton={false}
    />
  ) : (
    <>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
      >
        <BackdropCircularProgress
          open={
            isSubmitting
          }
          testId="T4 Slip List"
        />
        <DeleteConfirmationDialog
          open={openDialog}
          deleteActionHandler={bulkClientDelete === true ? deleteBulkClientField : deleteClientField}
          cancelActionHandler={onCloseHandler}
          testId="tax-profile-tab-confirmation-dialog"
        />
        <EnhancedDataGrid
          keyField={MoveClients ? MoveClients.keyField : undefined}
          onKeyFieldClickHandler={onKeyFieldClickHandler}
          columns={MoveClients && MoveClients.headerColumns ? MoveClients.headerColumns : []}
          // rows={MoveClients?.items}
          rows={MoveClients && MoveClients.items && moveClientsUpdatedItems && moveClientsUpdatedItems}
          selectionEnabled={true}
          autoHeight={true}
          allowSearching={true}
          onSearchButtonClicked={onSearchButtonClicked}
          searchFieldPlaceholder={"Search by Client Name..."}
          rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
          selectionToolbar={selectionToolbar}
          onRowEditClicked={onRowEditClicked}
          onRowDeleteClicked={onRowDeleteClicked}
          // initialPage={0}
          initialPageSize={INITIAL_PAGE_SIZE}
          disableColumnMenu={true}
          showRowActionsColumn={false}
          autoPageSize={false} //
          showIndexColumn={true}
          testId="client-list-grid"
          sortingMode="server"
          filterMode="server"
          paginationMode="server"
          onRequestParamsChange={onRequestParamsChange}
          onSearchCrossClicked={(value) => setzeroClient(value)}
          totalRowsCount={MoveClients?.total}
          isLoading={isLoading || isDeleting || isBulkDeleting}
          rowIdGetter={(row) => row.id}
          searchDebouncingDelay={SEARCH_DEBOUNCE_DELAY_IN_SECONDS}
          shouldMask={false}
          showLinearLoadingOverlay={true}
        />
      </Grid>
      <EnhancedSnackbar
        message={snackbarData.message}
        onCloseHandler={onSnackbarClosed}
        severity={snackbarData.severity}
        testId={`snackbar`}
        open={snackbarData.open}
      />
    </>
  );
};
